const navigationMobile = document.querySelector(".navigation-mobile");

if (navigationMobile) {
   const body = document.body;
   const btnMenu = document.querySelector(".navigation-toggle");

   // Null-Guard: Script nur ausführen wenn Toggle-Button vorhanden ist
   if (!btnMenu) {
      console.warn("navigation-mobile.js: .navigation-toggle fehlt.");
   } else {

      const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      // Bereiche hinter dem Overlay, die bei geöffnetem Menü nicht bedienbar sein sollen
      const backgroundSelector = 'main, footer, dialog.modal-custom';
      const headerLogo = document.querySelector(".header-logo");

      const isVisibleFocusable = (el) => !el.disabled && el.offsetParent !== null;

      const getMenuFocusableElements = () => Array.from(navigationMobile.querySelectorAll(focusableSelector))
         .filter(isVisibleFocusable);

      // Tab-Zyklus bei geöffnetem Menü: Header-Logo → Toggle → Menü-Links
      const getTrapElements = () => [headerLogo, btnMenu, ...getMenuFocusableElements()]
         .filter(el => el && isVisibleFocusable(el));

      const setBackgroundInert = (isInert) => {
         document.querySelectorAll(backgroundSelector).forEach(el => {
            el.toggleAttribute("inert", isInert);
         });
      };

      //Menu Hamburger
      const menuToggleOpen = () => {
         setTimeout(() => {
            body.style.overflow = "hidden";
            btnMenu.setAttribute("aria-expanded", "true");
            navigationMobile.classList.add("show");
            navigationMobile.removeAttribute("inert");
            setBackgroundInert(true);

            const focusableElements = getMenuFocusableElements();
            if (focusableElements.length > 0) {
               focusableElements[0].focus();
            }
         }, 1);
      };

      const menuToggleClose = () => {
         setTimeout(() => {
            body.style.overflow = "";
            btnMenu.setAttribute("aria-expanded", "false");
            navigationMobile.classList.remove("show");
            navigationMobile.setAttribute("inert", "");
            setBackgroundInert(false);
            btnMenu.focus();
         }, 1);
      };

      btnMenu.addEventListener('click', () => {
         if (btnMenu.getAttribute("aria-expanded") === "false") {
            menuToggleOpen();
         } else {
            menuToggleClose();
         }
      });

      // Fokus-Trap über Header (Logo, Toggle) und Mobile-Menü
      document.addEventListener('keydown', (event) => {
         if (event.code !== 'Tab') return;
         if (btnMenu.getAttribute("aria-expanded") !== "true") return;

         const focusableElements = getTrapElements();
         if (focusableElements.length === 0) return;

         const firstElement = focusableElements[0];
         const lastElement = focusableElements[focusableElements.length - 1];

         if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
         } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
         }
      });

      // Navigation mit Escape-Taste schließen
      document.addEventListener('keydown', (event) => {
         if (event.code === 'Escape' && btnMenu.getAttribute("aria-expanded") === "true") {
            menuToggleClose();
         }
      });
   }
}

// Dropdown
const dropdownButtons = document.querySelectorAll('.navigation__btn-dropdown');

dropdownButtons.forEach(button => {
   const submenuId = button.getAttribute('aria-controls');
   const submenu = document.getElementById(submenuId);

   if (!submenu) return;

   // Standard: Menü ist geschlossen
   button.setAttribute('aria-expanded', 'false');

   // Öffnen bei Leertaste oder Enter
   button.addEventListener('keydown', (event) => {
      if (event.code === 'Space' || event.code === 'Enter') {
         event.preventDefault(); // verhindert Scrollen bei Space
         submenu.classList.add('navigation__submenu--show');
         button.setAttribute('aria-expanded', 'true');
         submenu.querySelector('a, button')?.focus(); // Fokus ins Menü setzen
      }
   });

   // Schließen bei Escape
   submenu.addEventListener('keydown', (event) => {
      if (event.code === 'Escape') {
         submenu.classList.remove('navigation__submenu--show');
         button.setAttribute('aria-expanded', 'false');
         button.focus(); // Fokus zurück auf Button
      }
   });

   // Optional: Schließen, wenn Fokus ganz rausgeht
   submenu.addEventListener('focusout', (event) => {
      if (!submenu.contains(event.relatedTarget) && event.relatedTarget !== button) {
         submenu.classList.remove('navigation__submenu--show');
         button.setAttribute('aria-expanded', 'false');
      }
   });
});
